(function () {
  'use strict';
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* countdown: resets daily at local midnight so it is never "expired" */
  document.querySelectorAll('[data-hb-countdown]').forEach(function (el) {
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function tick() {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor((d % 3600) / 60)).padStart(2, '0');
      s.textContent = String(d % 60).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  });

  /* gallery */
  document.querySelectorAll('[data-hb-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-main]'), tiles = g.querySelector('.tiles');
    g.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; main.alt = b.dataset.alt || '';
        g.querySelectorAll('.thumbs button').forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
        if (tiles) tiles.style.display = b.dataset.tiles === '1' ? '' : 'none';
      });
    });
  });

  /* package pickers + add to cart */
  document.querySelectorAll('form[data-hb-buy]').forEach(function (form) {
    var fmt = form.dataset.moneyFormat;
    var btn = form.querySelector('[data-buy]');
    var priceNow = form.querySelector('[data-price-now]'), priceWas = form.querySelector('[data-price-was]'), savePill = form.querySelector('[data-save]');
    var btnPrice = form.querySelector('[data-btn-price]'), btnWas = form.querySelector('[data-btn-was]');
    function sync() {
      var r = form.querySelector('input[name="id"]:checked'); if (!r) return;
      var p = Number(r.dataset.price), c = Number(r.dataset.compare || 0);
      if (priceNow) priceNow.textContent = money(p, fmt);
      if (priceWas) { priceWas.textContent = c > p ? money(c, fmt) : ''; priceWas.style.display = c > p ? '' : 'none'; }
      if (savePill) { savePill.textContent = c > p ? (savePill.dataset.label || 'Save') + ' ' + money(c - p, fmt) : ''; savePill.style.display = c > p ? '' : 'none'; }
      if (btnPrice) btnPrice.textContent = money(p, fmt);
      if (btnWas) { btnWas.textContent = c > p ? money(c, fmt) : ''; }
      document.querySelectorAll('[data-sticky-title]').forEach(function (e) { e.textContent = r.dataset.title; });
      document.querySelectorAll('[data-sticky-price]').forEach(function (e) { e.textContent = money(p, fmt); });
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'id') sync(); });
    sync();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = form.querySelector('input[name="id"]:checked'); if (!r || !btn) return;
      var old = btn.innerHTML; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = btn.dataset.busy || 'Adding…';
      var go = form.dataset.redirect || '/checkout';
      fetch('/cart/clear.js', { method: 'POST' }).catch(function () {}).finally(function () {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1 }] }) })
          .then(function (res) { if (!res.ok) throw new Error('add'); window.location.href = go; })
          .catch(function () { btn.disabled = false; btn.innerHTML = old; form.removeAttribute('data-hb-buy'); form.submit(); });
      });
    });
  });

  /* sticky bar */
  var sticky = document.querySelector('[data-hb-sticky]'), anchor = document.querySelector('[data-hb-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var past = false, inPlans = false;
    function upd() { var on = past && !inPlans; sticky.classList.toggle('on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; upd(); }, { threshold: 0 }).observe(anchor);
    var plans = document.querySelector('[data-hb-plans]');
    if (plans) new IntersectionObserver(function (en) { inPlans = en[0].isIntersecting; upd(); }, { threshold: 0.2 }).observe(plans);
    var sBtn = sticky.querySelector('[data-sticky-buy]');
    if (sBtn) sBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.querySelector('form[data-hb-buy]'); if (form) { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }
    });
  }

  /* simple scroll carousels */
  document.querySelectorAll('[data-hb-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-track]'), dots = c.querySelectorAll('[data-dot]'), prev = c.querySelector('[data-prev]'), next = c.querySelector('[data-next]');
    var slides = track.children; function w() { return slides[0] ? slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) : 1; }
    function idx() { return Math.round(track.scrollLeft / w()); }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * w(), behavior: 'smooth' }); }
    function paint() { var i = idx(); dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); if (prev) prev.disabled = i === 0; if (next) next.disabled = i >= slides.length - 1; }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }); paint();
  });
})();
